<template>
  <div></div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "@/main";

const router = useRouter();
const route = useRoute();


onMounted(async () => {
  const token = route.query.token as string
  if (!token) {
    console.warn("No token provided")
    await router.push("/")
    return
  }
  try {
    console.log("signInWithCustomToken")
    await signInWithCustomToken(auth, token)
    await router.push("/")
  } catch (err) {
    console.warn(err)
    await router.push("/oauth/error?error=unknown_error")
  }
})
</script>
